import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EscapeHtmlPipe } from '../pipes/keep-html.pipe';
import { ReadableDatePipe} from '../pipes/readable-date.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    EscapeHtmlPipe,
    ReadableDatePipe
  ],
  exports: [
    EscapeHtmlPipe,
    ReadableDatePipe
  ]
})
export class PipesModule { }



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/utilities/pipes/pipes.module.ts